import React from "react";
import { adminLogin, apiError } from "./adminApi";

export default function AdminLogin({ onAuthed }) {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [busy, setBusy] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await adminLogin(username, password);
      onAuthed();
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-[#faf9f6] px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-xl border border-[#e4e3dc] bg-white p-7 shadow-sm"
        data-testid="admin-login-form"
      >
        <div className="mb-6 text-center">
          <div className="font-mono text-lg font-bold tracking-tight text-[#1b1b1b]">÷X</div>
          <h1 className="mt-1 text-xl font-extrabold tracking-[0.16em] pl-[0.16em]">NUMEX</h1>
          <p className="mt-1 text-xs uppercase tracking-widest text-[#75756f]">Admin</p>
        </div>

        <label className="mb-1 block text-xs font-medium text-[#75756f]">Username</label>
        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoComplete="username"
          className="mb-4 w-full rounded-lg border border-[#d7d6cf] px-3 py-2.5 text-sm outline-none focus:border-[#1b1b1b]"
          data-testid="admin-username"
        />
        <label className="mb-1 block text-xs font-medium text-[#75756f]">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          className="mb-5 w-full rounded-lg border border-[#d7d6cf] px-3 py-2.5 text-sm outline-none focus:border-[#1b1b1b]"
          data-testid="admin-password"
        />

        {error && (
          <p className="mb-4 text-sm text-red-600" data-testid="admin-login-error">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={busy}
          className="numex-cta w-full rounded-lg py-3 text-sm font-semibold tracking-widest disabled:opacity-60"
          data-testid="admin-login-btn"
        >
          {busy ? "SIGNING IN…" : "SIGN IN"}
        </button>
      </form>
    </div>
  );
}
